import * as React from "react";
import SEO from "../components/seo";
import Layout from "../components/layout";
import SimpleHero from "../components/v2/simple-hero";
import HeadlineBanner from "../components/v2/headline-banner";
import FiftyFiftyHorizontal from "../components/v2/fifty-fifty-horizontal";
import ImageGridBanner from "../components/v2/image-grid-banner";
import ContentBanner from "../components/v2/content-banner";
import MediaSlider from "../components/v2/media-slider";
import DetailsFooter from "../components/v2/details-footer";
import GetUpdates from "../components/v2/get-updates";

// Hooks
import useESLCPageImages from "../hooks/useESLCPageImages";
import ArrowLink from "../components/global/arrow-link";

const EvoSaltLake = () => {
  return (
    <Layout
      className="template-details"
      bodyTheme="light"
      isFooter={false}
      headerLayout="mobile"
    >
      <SEO title="evo Salt Lake" />
      <SimpleHero
        contentData={
          {
            pre_title: "evo",
            title: "Salt Lake",
          }
        }
        imageData={useESLCPageImages({name: "evo-salt-lake-city-2"})}
      />
      <HeadlineBanner
        className="spacing spacing--general"
        pre_title="A Welcoming place for"
        title="Our Community"
      />
      <FiftyFiftyHorizontal
        mediaPosition="left"
        contentColumns={5}
        contentOffset={1}
        mediaColumns={6}
        mediaOffset={0}
        imageData={useESLCPageImages({name: "evo-salt-lake-city-3"})}
      >
        <p>evo Salt Lake proudly showcases our unique blend of sports, culture, art, retail, and service. Whether you ski, snowboard, bike, wake, hike, or climb, we offer a welcoming space where our community can connect with like-minded people. Come by, say hi and hang out with people who love the outdoors as much as you do.</p>
        <p className="flex-copy">
          <span>Open daily, 10AM-7PM</span>
          <span><a className="dark" href="tel: +1 (385) 379-3172">(385) 379-3172</a></span>
          <span>
            <ArrowLink
              isExternalLink={true}
              to="https://www.evo.com/locations/salt-lake-city"
              text="Learn More"
              theme="dark-body"
            />
          </span>
        </p>
      </FiftyFiftyHorizontal>
      <ImageGridBanner
        className="spacing spacing--spacing-3"
        imageData={useESLCPageImages({name: "evo-salt-lake-city-4"})}
      />
      <FiftyFiftyHorizontal
        contentColumns={5}
        contentOffset={1}
        mediaColumns={5}
        mediaOffset={1}
        imageData={useESLCPageImages({name: "evo-salt-lake-city-5"})}
      >
        <p>While you’re here, visit our art gallery for a dose of creative inspiration. And make sure to check out our community wall for up-to-date information on local trail conditions, outdoor-related happenings and more.</p>
        <p>In addition, our shelves will be stocked with a curated selection of clothing and gear for the Salt Lake Area.</p>
      </FiftyFiftyHorizontal>
      <ContentBanner
        className="spacing spacing--general"
        title="Thoughtfully Curated Gear"
        description="We’ll have everything you need for skiing, snowboarding, mountain biking, skateboarding, camping and more. We’ll also offer a wide range of high-quality gear rentals; a convenient will-call experience; and full-service ski, snowboard, and bike shops"
      />
      <MediaSlider
        className="spacing spacing--general"
        slides={[
          {
            imageData: useESLCPageImages({name: "evo-salt-lake-city-6"}),
            description: "",
          },
          {
            imageData: useESLCPageImages({name: "evo-salt-lake-city-7"}),
            description: "",
          },
          {
            imageData: useESLCPageImages({name: "evo-salt-lake-city-8"}),
            description: "",
          },
          {
            imageData: useESLCPageImages({name: "evo-salt-lake-city-9"}),
            description: "",
          },
        ]}
      />
      <GetUpdates
        className="spacing spacing--general"
      />
      <DetailsFooter
        imageData={useESLCPageImages({name: "evo-salt-lake-city-1"})}
        imageDataHover={useESLCPageImages({name: "evo-salt-lake-city-10"})}
        linkData={{
          title: "Read Story",
          project_url: "/bouldering-project/",
        }}
        pre_title="Up Next"
        title="Bouldering Project"
      />
    </Layout>
  )
}

export default EvoSaltLake
